import { FDealType, FOfferType, isAvailable } from '../../../../JsonQuery';
import { IFilter } from '../../types/filters';
import { PosessorContainer } from '../../containers/filters/PosessorContainer';

export const posessor: IFilter = {
  availability: isAvailable(FDealType.Any, FOfferType.Any),
  component: PosessorContainer,
};
